import BaseService from './base.service';

export default class docUploadService extends BaseService {
  getRecognition() {
    return this.get('docupload/recognition/');
  }

  getProcess() {
    return this.get('docupload/process/');
  }

  uploadExcelCheck(formData) {
    return this.create('docupload/check/', formData);
  }

  getAgentStatus(agent) {
    return this.create('agent/status/', JSON.stringify({ agent }));
  }

  toggleAgent(agent) {
    return this.create('agent/toggle/', JSON.stringify({ agent }));
  }

  completeAds() {
    return this.create('ad/autocomplete', {});
  }
}
